/* global elementorFrontend, Swiper */
import $ from 'jquery';

export const sliderPopularTraining = () => {
	const el = {
		parent: '.mi-popular-training-container',
	};

	if (!$(el.parent).length) return;

	const toggleNavigationLock = function (swiperInstance, $container) {
		if (!swiperInstance || !swiperInstance.slides) return;
		const totalSlides = swiperInstance.slides.length;
		const slidesPerView = parseInt(swiperInstance.params.slidesPerView) || 1;

		$container.toggleClass('mi-popular-training--nav-locked', slidesPerView >= totalSlides);
	};

	const initSwiperForElement = function ($container) {
		const $slider = $container.find('.mi-popular-training-slider');
		if (!$slider.length) return;

		const $root = $slider.closest(el.parent);

		const slidesDesktop = parseInt($root.data('slides-desktop')) || 3;
		const slidesTablet = parseInt($root.data('slides-tablet')) || 2;
		const slidesMobile = parseInt($root.data('slides-mobile')) || 1;
		const isAutoplay = $root.data('autoplay') === true || $root.data('autoplay') === 'true';
		const autoSpeed = parseInt($root.data('autoplay-speed')) || 5000;

		const params = {
			slidesPerView: slidesMobile,
			spaceBetween: 24,
			loop: false,
			autoplay: isAutoplay ? { delay: autoSpeed, disableOnInteraction: false } : false,
			pagination: {
				el: $root.find('.mi-popular-training-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $root.find('.mi-popular-training-next')[0],
				prevEl: $root.find('.mi-popular-training-prev')[0],
			},
			breakpoints: {
				600: {
					slidesPerView: slidesTablet,
					spaceBetween: 24,
				},
				1024: {
					slidesPerView: slidesDesktop,
					spaceBetween: 24,
				},
			},
			on: {
				init: function () {
					toggleNavigationLock(this, $root);
				},
				breakpoint: function () {
					toggleNavigationLock(this, $root);
				},
				resize: function () {
					toggleNavigationLock(this, $root);
				},
			},
		};

		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.utils && elementorFrontend.utils.swiper) {
			const asyncSwiper = elementorFrontend.utils.swiper;
			new asyncSwiper($slider, params).then(function (newSwiperInstance) {
				$slider.data('swiper', newSwiperInstance);
				toggleNavigationLock(newSwiperInstance, $root);
			});
		} else if (typeof Swiper !== 'undefined') {
			const newSwiper = new Swiper($slider[0], params);
			$slider.data('swiper', newSwiper);
			toggleNavigationLock(newSwiper, $root);
		}
	};

	$(window).on('elementor/frontend/init', function () {
		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.hooks) {
			elementorFrontend.hooks.addAction(
				'frontend/element_ready/popular-training-slider.default',
				function ($element) {
					initSwiperForElement($element);
				}
			);
		}
	});

	// Immediate initialization for non-Elementor or pre-initialized frontend pages
	$(el.parent).each(function () {
		initSwiperForElement($(this));
	});
};

try {
	sliderPopularTraining();
} catch (error) {
	console.warn(error);
}
